import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { EsignatureDocumentListStore } from "../../store/EsignatureDocumentListStore";

type EsignatureDocumentListDialogsProps = {
  store: EsignatureDocumentListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de EsignatureDocument.
 * Separado para mantener EsignatureDocumentListPage más limpio.
 */
export const EsignatureDocumentListDialogs: React.FC<EsignatureDocumentListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
